import { useContext } from "react";
import { ProductObj } from "../../Types";
import { BundleBuilderBundleContext } from "./BundleBuilderBundle";
import { AvailableBundleBuilderTemplates } from "../../constants";
import { InspectorEditableBlock } from "../../CommonFields/InspectorEditableBlock";
import styles from "./BundleBuilderBundle.module.css"

export const RenderVariantInfo = ({
    product,
    alignment = "flex-start",
    style = {},
    bundleType = "",
}: {
    product: ProductObj;
    alignment?: string;
    style?: React.CSSProperties;
    bundleType?: string;
}) => {
    const { isMobile, bundleConfig } = useContext(BundleBuilderBundleContext);

    const filterProductOptions = (opt: any) => {
        if (opt?.name?.toLowerCase() == "title") {
            return false;
        } else {
            return true;
        }
    };

    const OPTIONS = product?.options?.filter(filterProductOptions) || [];
    // Prefer the variant's own selectedOptions (matched by option name) over splitting the
    // variant title on "/" — a single-option value like "Navy/Blue" contains a literal slash
    // and isn't a multi-option separator, so splitting the title on it truncates the value.
    const selectedOptions = product?.variants?.[0]?.selectedOptions || [];
    const getOptionValue = (optionName: string | undefined, idx: number) =>
        selectedOptions.find((so: any) => so.name === optionName)?.value ?? product?.title?.split(" / ")[idx];

    return (
        <InspectorEditableBlock bundleType={bundleType} settingKey="variantInfo">
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    justifyContent: "flex-start",
                    alignItems: alignment ? alignment : "flex-start",
                    fontSize: bundleConfig?.bundles_design.product_name_size - 2 + "px",
                    fontWeight: +bundleConfig?.bundles_design?.product_name_style?.split(" ")[0] - 100,
                    ...(bundleConfig?.selected_template_bb == AvailableBundleBuilderTemplates.HOVER_INFO_CARD && {
                        alignItems: "center",
                        width: "100%",
                    }),
                    ...style,
                }}
                className={styles.variantInformantion}
            >
                {(OPTIONS?.length || 0) > 0 ? (
                    OPTIONS?.map((option: any, idx: number) => {
                        return (
                            <div
                                style={{
                                    display: "-webkit-box",
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    alignItems: isMobile ? "center" : "flex-start",
                                    justifyContent: isMobile ? "space-between" : "flex-start",
                                    gap: isMobile ? 4 : 8,
                                    lineHeight: "normal",
                                }}
                                title={`${product.title}: ${getOptionValue(option.name, idx)}`}
                            >
                                {option.name}: {getOptionValue(option.name, idx)}
                            </div>
                        );
                    })
                ) : product?.options?.[0]?.name?.toLowerCase() != "title" ? (
                    <div
                        style={{
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            alignItems: isMobile ? "center" : "flex-start",
                            justifyContent: isMobile ? "space-between" : "flex-start",
                            gap: isMobile ? 4 : 8,
                            lineHeight: "normal",
                        }}
                        title={`${product?.options?.[0]?.name}: ${getOptionValue(product?.options?.[0]?.name, 0)}`}
                    >
                        {product?.options?.[0]?.name}: {getOptionValue(product?.options?.[0]?.name, 0)}
                    </div>
                ) : (
                    <></>
                )}
            </div>
        </InspectorEditableBlock>
    );
};

const BBProductCard = () => {
    return <div>BBProductCard</div>;
};

export default BBProductCard;
